import { useQuery } from '@tanstack/react-query';
import type { HistoryLease, OwnedHistory } from '@vuokramani/shared';
import { api } from './api.ts';

const BASE = import.meta.env.VITE_API_URL ?? '/api';

/** Vuokralaisen päättyneet vuokrasuhteet. */
export function useTenantHistory() {
  return useQuery({
    queryKey: ['history'],
    queryFn: () => api<{ leases: HistoryLease[] }>('/history').then((r) => r.leases),
  });
}

/** Vuokrasuhteen koko aineisto zipinä: loki, laskut, maksut ja tarkastukset. */
export const leaseExportUrl = (leaseId: string) => `${BASE}/leases/${leaseId}/export.zip`;

/** Vuokranantajan historia: asunnoittain päättyneet vuokrasuhteet. */
export function useOwnedHistory() {
  return useQuery({
    queryKey: ['history', 'owned'],
    queryFn: () => api<OwnedHistory>('/history/owned'),
  });
}

/** Asunnon koko aineisto zipinä (vain omistaja). */
export const propertyExportUrl = (propertyId: string) =>
  `${BASE}/properties/${propertyId}/export.zip`;

/** Kaikki omat asunnot yhdessä zipissä. */
export const accountExportUrl = () => `${BASE}/export.zip`;
